<template>
  <svg
    class="-rotate-90"
    :class="this.class"
    width="41"
    height="30"
    viewBox="0 0 41 30"
    role="img"
    :aria-label="$t('android.accessibility.revert.answer')"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.4352 0.561379L1.55996 13.4366C1.18338 13.8132 0.996265 14.3075 0.998604 14.801C0.996441 15.2593 1.15763 15.7183 1.48217 16.083L1.55996 16.1654L14.4352 29.0407C15.1837 29.7892 16.3973 29.7892 17.1458 29.0407C17.8693 28.3171 17.8934 27.159 17.2181 26.4065L17.1458 26.3301L7.58762 16.7708H38.1029C39.1614 16.7708 40.0195 15.9127 40.0195 14.8542C40.0195 13.7956 39.1614 12.9375 38.1029 12.9375H7.48028L17.1458 3.27195C17.8943 2.52345 17.8943 1.30988 17.1458 0.561379C16.3973 -0.187126 15.1837 -0.187126 14.4352 0.561379Z"
    />
  </svg>
</template>

<script>
export default {
  name: "ArrowDownIcon",
  props: {
    class: String,
  },
};
</script>
